import { Component, OnInit, ElementRef, Input, EventEmitter, Output, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import Picker from 'vanilla-picker';
import { HexString } from 'src/app/types/@types/hex-string';
import { ColorPickerDialogService, ColorType } from '../dialogs/color-picker-dialog/color-picker-dialog.service';
import { request } from 'http';
@Component({
  selector: 'app-color-picker-input',
  templateUrl: './color-picker-input.component.html',
  styleUrls: ['./color-picker-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ColorPickerInputComponent implements OnInit {

  // tslint:disable-next-line: variable-name
  _color: HexString = '#000000';

  @Output()
  colorChange = new EventEmitter<HexString>();

  @Input()
  set color(newColor: HexString) {
    const oldColor = this._color;

    if (newColor === 'trans') {
      newColor = '#00000000';
    }
    const sameColor = (newColor === oldColor);
    if (newColor.substring(0, 1) !== '#') {
      newColor = '#' + newColor;
    }
    this._color = newColor;

    if (!sameColor) {
      this.colorChange.emit(this.color);
      this.Refresh();
    }
    if (!this.cssVar || this.cssVar === '') return;
    requestAnimationFrame(() => {
      const cs = getComputedStyle(document.documentElement);
      const varName = '--' + this.cssVar;
      const color = cs.getPropertyValue(varName);
      if (color !== this._color) {
        document.documentElement.style.setProperty(varName, this._color);
      }
      this.Refresh();

    });

  }
  get color() {
    if (this._color.length === 9) {
      return 'trans';
    }
    return this._color;

  }

  @Input()
  icon = '';

  @Input()
  public type: ColorType = 'wheel';

  @Input()
  includeInput = true;

  @Input()
  direction = 'bottom';

  @Input()
  colorFor = '';
  @Input()
  colorParent = this.domNode.nativeElement;

  private cssVar: string;
  @Input()
  set color_css_var(styleName: string) {
    this.cssVar = styleName;
    const cs = getComputedStyle(document.documentElement);
    const varName = '--' + styleName;
    const color = cs.getPropertyValue(varName);
    this._color = color;
    this.colorChange.emit(this.color);
    this.Refresh();
  }

  @Input() isTransparent = false;
  @Output() isTransparentChange = new EventEmitter<boolean>();
  private picker;

  private _ready: boolean = false;
  constructor(private domNode: ElementRef, private colorPickerSvc: ColorPickerDialogService, private cdr: ChangeDetectorRef) {
    this.colorParent = this.domNode.nativeElement;
  }
  ShowPicker() {
    let showColor: HexString = this._color;
    if (showColor.length === 9) {
      showColor = '';//showColor.substr(0, 7);
    }
    this.colorPickerSvc.Show((color) => {
      this.color = color;
      this.colorChange.emit(this.color);
    }, showColor, this.colorFor, this.type);
  }
  HandleValueChange(event) {
    this.color = event.target.value;
    this.colorChange.emit(this.color);
    this.Refresh();
  }
  ngOnInit() {
    this._ready = true;
    if (this.color === 'trans') {
      this.isTransparent = true;
      this.isTransparentChange.emit(this.isTransparent);
    }
    this.Refresh();
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }
}
